

























import {Component, Vue, Prop} from 'vue-property-decorator'

@Component
export default class Pager extends Vue {
  @Prop({required: true}) pageCount!: number
  @Prop({required: true}) pageIndex!: number

  get pages(){
    const pages = [] as number[]
    for(let item = 1; item < this.pageCount + 1; item++){
      pages.push(item)
    }
    return pages
  }

  public isShowPage(page){
    return page < this.pageIndex + 5 && page > this.pageIndex - 5
  }

  public reroutePage(page: number){
    if(page >= 1 && page <= this.pageCount){
      this.$emit('reroutePage', page)
    }

  }

}
